module.exports = __webpack_public_path__ + "static/media/Openbite7.1d3df4fe.png";